import { LoadingState } from '../../helpers/apiRequestSlice';
import { AppState } from '../../init/rootReducer';
import { InventoryAlertsState } from './slices';

export const getInventoryAlertsState = (state: AppState): InventoryAlertsState =>
  state.containers.inventoryAlerts;

export const getInventoryAlertsLoadingState = (state: AppState): LoadingState =>
  state.containers.inventoryAlertsLoading;
